import React, { useState } from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Card } from '../../../_shared/components/Card/Card';
import { KpiTableFacts } from '../../../_shared/components/KpiTableFacts/KpiTableFacts';
import { mockCardEfficiencyList, mockKpiFacts } from '../../../_shared/mocks';
import { KpiItem } from '../../../_shared/types';
import { CardEfficiency } from '../../components/CardEfficiency/CardEfficiency';
import styles from './ManagerFacts.module.scss';

export function ManagerFactsView() {
  const [selectedKpi, setSelectedKpi] = useState<KpiItem | null>(null);

  return (
    <div className={styles.view}>
      <div className={styles.head}>
        <div className={styles.headInfo}>
          <Typography variant="h2">Мои КПЭ</Typography>
          <Typography variant="text">
            Вам необходимо проверить и подтвердить фактические значения по
            показателям КПЭ за 2026 год.
            <br />
            Часть данных загружена автоматически из внутренних систем. При
            необходимости вы можете подать апелляцию.
          </Typography>
        </div>
      </div>
      <div className={styles.cardsBlock}>
        <Card>
          <KpiTableFacts
            rows={mockKpiFacts}
            editable
            onKpiClick={(row) => setSelectedKpi(row as KpiItem)}
            onEdit={(row) => console.log('edit', row)}
            onDelete={(row) => console.log('delete', row)}
          />
        </Card>
        <div className={styles.cards}>
          {mockCardEfficiencyList.map((item, index) => (
            <CardEfficiency
              key={index}
              number={item.character}
              title={item.title}
              content={item.content}
              statusName={item.statusName}
              status={item.status}
            />
          ))}
        </div>
      </div>
      <Typography variant={'h2'}>Мои подчиненные</Typography>
      <Typography variant={'h3'} className={styles.name}>
        Иванов И.И.
      </Typography>
      <div className={styles.cardsBlock}>
        <Card>
          <KpiTableFacts
            rows={mockKpiFacts}
            editable
            onKpiClick={(row) => setSelectedKpi(row as KpiItem)}
            onEdit={(row) => console.log('edit', row)}
            onDelete={(row) => console.log('delete', row)}
          />
        </Card>
        <div className={styles.cards}>
          {mockCardEfficiencyList.map((item, index) => (
            <CardEfficiency
              number={item.character}
              title={item.title}
              content={item.content}
              statusName={item.statusName}
              status={item.status}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
